import fetchActionsName from './fetchActionsName'

export default fetchActionsName

export enum ActionNames {
  CreateRoom = 'Create room in API',
  RemoveRoom = 'Remove room from API',
  FetchCalendars = 'Fetch active calendars',
  FetchRoom = 'Fetch rooms from API',
  UpdateRoom = 'Updated room in API',
  FetchSelectedColumns = 'Fetch selected columns in API',
  UpdateSelectedColumns = 'Update selected columns from API',
  LoadEvents = 'Load events from API (fallback)',
  LoadCurrencies = 'Load currencies from API',
  LoadLicenses = 'Load licencse from API',
  FetchUser = 'Fetch user from API',
  FetchCountries = 'Fetch countries from API',
  FetchObject = 'Fetch object type from API',
  FetchProvenances = 'Fetch provenances from external API',
  Synchronize = 'Synchronize API with redux state',
  FetchTemplates = 'Fetch templates from external API',
  UpdateLanguage = 'Update language in API',
  FetchWidget = 'Fetch widget settings from API',
  UpdatePassword = 'Update password in API',
  LoadUserProfile = 'Load user profile from API',
  UpdateWidgets = 'Load widget settings from API',
  LoadSettings = 'Load settings from API',
  DeleteUserLogo = 'Delete user logo from API',
  UpdateUserLogo = 'Update user logo from API',
  UpdateUserProfile = 'Save user profile to API',
  UpdateUser = 'Request save user to API',
  RequestUserUpdate = 'Request user update from API',
  ValidateDate = 'Validate date',
  SortRooms = 'Request rooms sort',
  FetchPaymentDictionary = 'Fetch type of payment dictionaries from external API',
  AddPaymentDictionary = 'Add type of payment dictionaries to external API',
  DeletePaymentDictionary = 'Remove payments from API',
  LoadServices = 'Fetch services from API',
  CreateProvenance = 'Request create provenance',
  CalculatePrice = 'Calculate end price for reservation',
  DeleteEvent = 'request delete event',
  TransferEvent = 'request API to transfer room',
  CreateEvent = 'Request create Event in API',
  UpdateEvent = 'Request update event in Api',
  FetchEventPdf = 'Fetch event pdf from API',
  LoadLimits = 'Fetch limits from API',
  UpdateLimits = 'Update user limits in API',
  FetchNotifications = 'Fetch notification page from API',
  MarkNotificationAsRead = 'Mark notification(s) as read in API',
  MarkNotificationAsSeen = 'Mark notification(s) as seen in API',
  DeleteNotification = 'Delete notification(s) from API',
  SendNotificationError = 'Send notification error to API',
  FetchInvoice = 'Fetch invoice from API',
  CreateInvoice = 'Create invoice in API',
  AddSelectedColumn = 'Add selected column in API',
  DeleteSelectedColumn = 'Delete selected column in API',
  FetchPriceConfiguration = 'Fetch price configuration from API',
  UpdatePriceConfiguratuion = 'Update Price configuration in API',
  UpdatePriceConfiguratuionPrice = 'Update Price configuration in AP price',
  UpdatePriceConfiguratuionAcc = 'Update Price configuration in AP acc',
  UpdatePriceConfiguratuionFee = 'Update Price configuration in AP fee',
  UpdatePriceConfiguratuionKids = 'Update price configuration kids in API',
  UpdatePriceConfiguratuionFood = 'Update price configuration food in API',
  UpdatePriceConfiguratuionTax = 'Update price configuration tax in API',
  FetchPrices = 'Fetch prices from API',
  SavePriceForm = 'Save price form in API',
  SaveTemplate = 'Save template in API',
  FetchTaxes = 'Fetch taxes from API',
  FetchInvoiceSettings = 'Fetch invoice settings from API',
  UpdateTaxes = 'Save taxes in API',
  UpdateInvoiceSettings = 'Save invoice settings in API',
  FetchDefaultServices = 'Fetch default services from API',
  FetchServices = 'Fetch services from API',
  UpdateDefaultServices = 'Save default services in API',
  UpdateServices = 'Save services in API',
  UpdatePrepayments = 'Save prepayments in API',
  UpdatePaymentMethod = 'update payment method in API',
  FetchPaymentMethod = 'Fetch payment method from API',
  SavePhotos = 'Save photos in API',
  ResetPassword = 'Send reset password email in API',
  FetchBoxBuyIntegration = 'Fetch integration from API',
  FetchAirbnbIntegration = 'Fetch integration from API',
  CreateAirbnbIntegration = 'Create airbnb integration in API',
  CreateBoxBuyIntegration = 'Create boxbuy integration in API',
  DisconnectBoxBuyIntegration = 'Disconnect boxbuy integration in API',
  FetchAirbnbListings = 'Fetch airbnb integration listings from API',
  ToggleAirbnbSync = 'Toggle airbnb integration sync in API',
  DeleteListing = 'Delete airbnb integration listing in API',
  FetchAirbnbPrices = 'Fetch airbnb prices from API',
  FetchFacilities = 'Fetch facilities from API',
  FetchRentLicenses = 'Fetch rent licensees from API',
  DeleteRentLicenses = 'Delete rent licensees from API',
  SaveRentLicenses = 'Save rent licensees in API',
  FetchObjectFacilities = 'Fetch object facilities from API',
  SaveAirbnbPriceForm = 'Save airbnb prices in API',
  FetchAirbnbRoomConfiguration = 'get airbnb room configuration from API',
  SaveAirbnbConfiguration = 'save airbnb room configuration in API',
  SetIcalendarToken = 'set icalendar token in API',
  FetchIcalendarSettings = 'fetch icalendar settings from API',
  SaveIcalSettings = 'save icalendar settings in API',
  SetPropertyId = 'save propertyId in API',
  SetBookingStatus = 'save booking status in API',
  FetchBookingSettings = 'fetch booking settings from API',
  FetchBookingRooms = 'fetch booking rooms from API',
  StartBookingSyncingRooms = 'start booking room syncing in API',
  SaveBookingMappings = 'save booking mappings in API',
  ConfirmBooking = 'confirm booking mappings in API',
  UnconfirmBooking = 'unconfirm booking mappings in API',
  ValiateBookingConfiguration = 'validate booking configuration in API',
  CreateInvoiceService = 'create invoice service in API',
  fetchBookingMultiList = 'fetch Booking list multi from API',
  DeleteUser = 'delete user in API',
  UpdatePriceConfiguratuionKidsTax = 'save price kids tax configuration in API',
  CreateEmployee = 'create employee in API',
  FetchEmployees = 'fetch employees from API',
  DeleteEmployee = 'delete employee from API',
  UpdateEmployee = 'update employee in API',
  LoadEverything = 'load all from API',
  CreateBookingMulti = 'create booking connection in API',
  SaveBookingMultiName = 'save booking name in API',
  DeleteBookingMulti = 'delete booking property in API',
  CheckBookingProperty = 'check booking property in API',
  CreateStripeAccount = 'create stripe account in API',
  CompleteStripeAccount = 'complete stripe account in API',
  FetchNewPrices = 'fetch new prices from API',
  FetchPriceRoomSettings = 'fetch price room Grid settings from API',
  SavePriceForm2 = 'save price form 2 in API',
  CopyPricelist = 'copy pricelist in API',
  PutRoomSettingsGrid = 'put room settings Grid in API',
  FetchPriceGlobalRoomSettings = 'fetch price global room settings from API',
  ToggleMultiPrices = 'toggle multi prices in API',
  SaveBookingMappingImport = 'save booking mapping import in API',
  SetPriceDisplayed = 'set price config displayed in API',
  SetSurveyModalShow = 'set survey modal show in API',
  SaveCookiesInApi = 'save cookies in API',
  SaveReservationFormSettingsInApi = 'save reservation form settings in API',
  FetchCookiesInfo = 'fetch cookies info from API',
  FetchGoogleHotel = 'fetch google hotel from API',
  SaveGoogleHotel = 'save google hotel in API',
  SaveGoogleHotelStatus = 'save google hotel status in API',
  ConfirmBookingProperty = 'start confirming booking property in API',
  SetPriceSwitch = 'set price switch in API',
  LoadSubs = 'load subs from API',
  CancelSub = 'cancel sub in API',
}
